import React from "react";
import { labels } from "../../../localization/labels";
import ExtensionService from "../../../services/ExtensionService";
import RouteUtil from "../../../utils/RouteUtil";
import { paths } from "../../paths";
import PageComponent from "../page/PageComponent";
import AdvancedSearch from "./AdvancedSearch";
import { constants } from "../../../utils/Constants";
import SecurityUtils from "../../../utils/SecurityUtils";

class AdvancedSearchContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      advancedSearchParams: RouteUtil.getLocationParameter(
        props,
        "advancedSearchParams"
      ),
      extensions: [],
      classificationsFilter: SecurityUtils.geClassificationsByOperation(
        constants.OPERATION_READ
      )
    };
    this.extensionService = new ExtensionService();
  }

  componentDidMount() {
    this.loadExtensions();
  }

  loadExtensions = () => {
    this.prepareCall(
      this.extensionService.getEntities(
        undefined,
        this.sortInfo,
        this.onExtensionsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onExtensionsLoad = data => {
    if (data && data._embedded && data._embedded.content) {
      const extensions = data._embedded.content;
      this.setState({ extensions: extensions });
    }
  };

  handleDialogChange = event => {
    const { advancedSearchParams } = this.state;
    advancedSearchParams[event.target.id].filterVal = event.target.value;
    this.setState({ advancedSearchParams });
  };

  handleAdvancedSearch = () => {
    this.changePath(paths.KNOWLEDGE_MANAGMENT, labels.knowledgeManagement, {
      advancedSearchParams: this.state.advancedSearchParams
    });
  };

  resetAdvancedSearchParams = () => {
    const { advancedSearchParams } = this.state;
    Object.keys(advancedSearchParams).forEach(function (key) {
      const advancedSearchParam = advancedSearchParams[key];
      advancedSearchParam.filterVal = undefined;
      advancedSearchParams[key] = advancedSearchParam;
    });
    this.setState({ advancedSearchParams });
  };

  onSelectClassification = classificationArray => {
    classificationArray.forEach(item => {
      if (item) {
        const { id, name } = item;
        const { advancedSearchParams } = this.state;
        const classifications = advancedSearchParams.classifications;
        if (!classifications.filterVal) {
          classifications.filterVal = [];
        }
        const existingClassification = classifications.filterVal.find(
          item => item.id === id
        );
        if (!existingClassification) {
          classifications.filterVal.push({ id, name });
          this.setState({
            advancedSearchParams: {
              ...this.state.advancedSearchParams,
              classifications: classifications
            }
          });
        }
      }
    });
  };

  getComponentTitle = () => {
    return labels.advancedSearch;
  };

  render() {
    return (
      <AdvancedSearch
        handleAdvancedSearch={this.handleAdvancedSearch}
        advancedSearchParams={this.state.advancedSearchParams}
        handleDialogChange={this.handleDialogChange}
        resetAdvancedSearchParams={this.resetAdvancedSearchParams}
        extensions={this.state.extensions}
        onSelectClassification={this.onSelectClassification}
        {...this.handlerProps()}
        classifications={
          this.state.advancedSearchParams.classifications.filterVal
        }
        classificationsFilter={this.state.classificationsFilter}
      />
    );
  }
}

export default AdvancedSearchContainer;
